import { render, staticRenderFns } from "./LoginBox.vue?vue&type=template&id=256925bc"
import script from "./LoginBox.vue?vue&type=script&lang=js"
export * from "./LoginBox.vue?vue&type=script&lang=js"
import style0 from "./LoginBox.vue?vue&type=style&index=0&id=256925bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports